import type { ComponentProps, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import { TONE_ICONS, TONE_ICON_COLORS, type ToastTone } from './tones'

interface ToastIconProps extends Omit<ComponentProps<'span'>, 'children'> {
  tone?: ToastTone
  /** Replaces the tone's default glyph. */
  children?: ReactNode
}

/** A 14px status glyph. Decorative: the message carries the meaning. */
function ToastIcon({ tone, className, children, ...props }: ToastIconProps) {
  const Default = tone ? TONE_ICONS[tone] : null
  return (
    <span
      data-slot="toast-icon"
      aria-hidden
      className={twMerge(
        'flex shrink-0 items-center [&_svg:not([class*="size-"])]:size-3.5',
        tone && TONE_ICON_COLORS[tone],
        className,
      )}
      {...props}
    >
      {children ?? (Default ? <Default /> : null)}
    </span>
  )
}

export { ToastIcon }
